import React, { Component } from 'react'
import ReactTable from 'react-table'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Datetime from 'react-datetime';
import { _delete, get, postWithHeaders } from '../../../server/actions';
import moment from 'moment';
import $ from 'jquery'
import { BeatLoader } from 'react-spinners';
import 'react-tabs/style/react-tabs.css';
import NotificationSystem from 'react-notification-system';
import CustomSubmit from '../../Misc/customSubmit';
import { _addNotification, _addNotificationError, getSchoolGrades } from '../../../server/util';
import { date_format } from '../../../server/constants';
import MenuOptions from '../../Misc/MenuOptions/menuOptions';
import { getTransactionOptions } from '../../Misc/MenuOptions/menuOptionsActions';


const today = moment();
let schoolId = sessionStorage.getItem('SchoolId'); 

const disableFutureDt = current => {
  return current.isBefore(today)
}
let gradeList = [];

export default class bulkOrdersGrid extends Component {
    
    
    constructor(props) { 
        super(props);
        this.state = {
            loading: false,
            startDate: moment().startOf('day'),
            data: [],
            orderData: [],
            updatedData: [],
            selection: [],
            selectAll: false,
            columns: [],
            selectedTab: 0,
            selectType: "checkbox",
            mealType: (getTransactionOptions()[0] || ''),
        };
        this.renderInput=this.renderInput.bind(this);
    }

    clearAll = () => { 
        this.setState({
            data: [],
            orderData: [],
            selection: [],
            selectAll: false,
            mealType: (getTransactionOptions()[0] || ''),
            loading: false,
        })
    }

    componentWillMount = () => { 
        let schoolId = sessionStorage.getItem('SchoolId'); 
        new Promise((() => {
            this.setState({loading: false})
            this.setState({ columns: this.getColumns() })
            this.getTableData(moment(this.state.startDate).format('YYYY-MM-DD'),schoolId)
        }))
    }
    
    componentDidMount = () => { 
        const { selection, data } = this.state
        const selectAll = data.length > 0 && selection.length === data.length;
        this.setState({ selectAll });
        this._notificationSystem = this.refs.notificationSystem;
    }
    
    componentDidUpdate = (prevProps, prevState) => { 
        if (prevState.selectAll !== this.state.selectAll || prevState.selection.length !== this.state.selection.length) { 
            new Promise((() => {
                this.setState({ columns: this.getColumns() })
                this.getTableData(moment(this.state.startDate).format('YYYY-MM-DD'),schoolId)
            }))
        }
    }

    getSystemDateTime = () => { 
        return moment(this.state.startDate).format('YYYY-MM-DD');
    }


    handleTabChange = (tabName) => {
        if (tabName === 0) { 
            this.setState({ selectedTab: 0 })
        } else {
            this.setState({ selectedTab: tabName.toLowerCase() });
        }
        
    }

    getBulkOrdersMenu = async(selectedDate,schoolId) =>{
        this.setState({loading: true});
        await get(`/cep/${schoolId}/menuWithorders/${this.state.mealType}/${selectedDate}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            this.setState({data: data.resp.availableMenu, orderData: data.resp.hasOwnProperty('orderMenu') ? data.resp.orderMenu : null })
        }).catch(error => {
            this.setState({loading: false});
        })
    }
    
    handleCountChange = (id, value) => {
        let tabData = this.state.data.map((item) => ({
            ...item,
            count: item.id === id ? (value >= 0 ? parseInt(value) : 0) : item.count,
        }));

        let selectionData = this.state.selection.map((item) => {
            if (item.id === id) {
                return { ...item, count: value >= 0 ? parseInt(value) : 0 };
            }
            return item;
        });

        this.setState({ data: tabData, selection: selectionData });
    };


    toggleSelection = (row) => {
        
        const { selection, data } = this.state;
        const isChecked = selection.some((obj) => obj.id === row._original.id);

        if (isChecked) {
            const updatedSelection = selection.filter((item) => item.id !== row._original.id);
            const selectAll = updatedSelection.length === data.length;
            this.setState({ selection: updatedSelection, selectAll });
        } else {
            const updatedRow = { ...row._original, count: row._original.count }; // updating the count value from input field
            const updatedSelection = [...selection, updatedRow];
            const selectAll = updatedSelection.length === data.length;
            this.setState({ selection: updatedSelection, selectAll });
        }

    };

    
    toggleAll = () => {
        const { selectAll, data } = this.state
        let isSelectAll = !selectAll
        this.setState({ selectAll: isSelectAll, selection: isSelectAll ? data : [] })
    };


    
    
    getTableData = async (selectedDate, schoolId) => { 
        this.setState({ loading: true })

        schoolId = schoolId !== null ? schoolId : sessionStorage.getItem('SchoolId')

        await get(`/cep/${schoolId}/menuWithorders/${this.state.mealType}/${selectedDate}?access_token=`).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            let allRows = Object.entries(data.resp.availableMenu).flatMap(([grade, tabData]) =>
                Object.entries(tabData).flatMap(([mealType, rowData]) =>
                    rowData.filter((row) => row !== undefined && row !== null && !row.mealName.includes("No School")).map((row, index) => ({
                        id: grade+"_"+mealType+"_"+index.toString(),
                        grade: grade,
                        mealType: mealType,
                        mealId: row.mealId.toString(),
                        itemName: row.mealName,
                        count: row.orderCount,
                    }))
                )
            );
            this.setState({ data: allRows, orderData: data.resp.hasOwnProperty('orderMenu') ? data.resp.orderMenu : null, loading: false })
        }).catch((error) => {
            console.log('API request failed. Check query params', error);
            this.setState({ loading: false })
        })
        
    }
    
    getColumns() {
        let columns = [];
        const { selectAll, selection } = this.state;

        columns.push({
            Header: (
                <input
                    type={'checkbox'}
                    checked={selectAll}
                    onChange={() => this.toggleAll()}
                />
            ),
            accessor: 'checkbox',
            Cell: ({ row }) => (
                <input
                    type="checkbox"
                    checked={selection.some((obj) => obj.id === row._original.id) ? true : selectAll }
                    onChange={(event) => this.toggleSelection(row)}
                />),
            style: { textAlign: 'center', textTransform: 'capitalize' },
            width: 50,
            sortable: false,
            filterable: false,
        });
                    
        columns.push({
            accessor: 'itemName',
            Header: 'ITEM NAME',
            Cell: '',
            style: { textAlign: 'left', textTransform: 'capitalize' }
        });
        columns.push({
            Header: 'COUNT',
            Cell: ({ row }) => <input type="number" min='0' className={'form-control-sm'} placeholder={row._original.count}  onChange={(event) => this.handleCountChange(row._original.id, event.target.value)} />,
            style: { textAlign: 'center' }
        });
        
        
        return columns;
    }
    
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    
    renderTableData = () => {

        const { selectedTab, data } = this.state;

        // Load data for ALL tab
        if (selectedTab === 0) {
            return data;
        }

        // Load data for specific grade 
        if (selectedTab !== 0) {
            let filteredRows = data.filter((row) => row.grade === selectedTab);
            return filteredRows.length > 0 ? filteredRows : [];
        } else { 
            return [];
        }
    };
  
    saveOrders = (e, callback) => { 

        let {selection, orderData} = this.state
        let updatedRequestBody = []

        if (selection.length > 0) { 

            // Formating requestBody data as per post API body request 
            let requestBody = selection.reduce((result, row) => {
                const existingItem = result.find((item) => item.grade === row.grade && item.mealType === row.mealType);
                
                if (existingItem) {
                    existingItem.qty += row.count;
                    existingItem.menuItems.push({
                    menuItemId: parseInt(row.mealId),
                    qty: parseInt(row.count),
                });
                } else {
                    result.push({
                        orderId: 0,
                        grade: row.grade,
                        mealType: row.mealType,
                        qty: row.count,
                        menuItems: [
                            {
                                menuItemId: parseInt(row.mealId),
                                qty: parseInt(row.count),
                            },
                        ],
                    });
                }
                return result;
            }, []);


            if(orderData !== null){  
                // Adding order details if order is exists
                updatedRequestBody = requestBody.map((item) => {
                    let matchingOrder = orderData.find(
                        (order) =>
                        order.grade === item.grade &&
                        order.mealType === item.mealType &&
                        item.menuItems.some((menuItem) => menuItem.menuItemId === order.menuItems[0].menuItemId)
                    );

                    if (matchingOrder) {
                        item.menuItems.forEach((menuItem) => {  
                            let matchingMenuItem = matchingOrder.menuItems.find(
                            (orderMenuItem) => orderMenuItem.menuItemId === menuItem.menuItemId
                        );
                        if (matchingMenuItem) {
                            menuItem.orderMenuId = parseInt(matchingMenuItem.orderMenuId);
                        }});
                
                        item.orderId = parseInt(matchingOrder.orderId);
                    }
            
                    return item;
                });
            }



            // Reorder the menuItems array to have orderId and orderMenuId at the beginning
            // let finalRequestBody = requestBody.map((item) => {
            //     if (item.orderId) {
            //         let updatedMenuItems = item.menuItems.map(({ orderMenuId, menuItemId, qty }) => ({orderMenuId, menuItemId,qty }));
            //         return {
            //         orderId: item.orderId,
            //         ...item,
            //         menuItems: updatedMenuItems
            //         };
            //     }
            //     return item;
            // });


            // Check if each object in finalRequestBody has the orderId property, if not, add "orderId: 0"
            // let finalRequestBody = requestBody.map((item) => {
            //     if (!item.hasOwnProperty('orderId')) {
            //         return { ...item, orderId: 0 };
            //     }
            //     return item;
            // });




            let headers = {
                'Content-Type': 'application/json'
            };
        
            let schoolId = sessionStorage.getItem('SchoolId');


            
            postWithHeaders(`/cep/${schoolId}/orders/${this.state.mealType}/${this.getSystemDateTime()}?access_token=`, JSON.stringify(requestBody), headers).then((response) => {
                if (response.status === 200) {
                    this.setState({ loading: false })
                    _addNotification('Order placed successfully.', this);
                    callback(true);
                    this.clearAll()
                } else if (!response.ok) {
                    console.log("Error Response: ",response)
                    throw Error(response.status);
                }else{
                    _addNotificationError('Please select at least one Item.', this);
                    callback(true);
                }  
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    callback(true);
                    _addNotificationError(`Failed to order items! Getting ${error} status. Please check API request`, this);
                }
            );
        }else{
        _addNotificationError('Please select at least one item.', this);
        callback(true);
    }  
    }
    
    render() {
        gradeList= getSchoolGrades();
        const tableData = this.renderTableData()
        const checkboxProps = {       
            selectType: "checkbox", 
            
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover",
                }
            },
        };
        {
            $('#selector button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
            })
        }
        try {
            $("#selector>button.active").removeClass("active");
            document.getElementById(this.state.action).classList.add("active")
        } catch (error) {
        }
        return (
            <div>
            <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className="container">
                        <div className='sweet-loading'
                            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="sectionTitle">
                            <div className="row">
                                <div className="col-md-2">
                                    <h2><span>Add Orders</span></h2>
                                </div>
                                <div className="uploadFileInfo col-md-4 createmenu-month-group">
                                    <div className="input-group col-md-8 col-sm-12 col-xs-12" style={{margin: '15px 0 0 12px'}}>
                                    <Datetime ref='trCalendar' dateFormat={date_format()} timeFormat={false}
                                                                    closeOnSelect={true} value={moment(this.state.startDate,'YYYY-MM-DD')}
                                                                    onChange={(e)=>{
                                                this.setState({startDate:moment(e).format('YYYY-MM-DD')});
                                                let schoolId = sessionStorage.getItem('SchoolId'); 
                                                this.getTableData(moment(e).format('YYYY-MM-DD'),schoolId);                        
                                                this.refs.trCalendar.closeCalendar();
                                            }} renderInput={this.renderInput}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pull-right" style={{marginBottom:'5px'}}>
                            <div style={{display:'inline-block'}}>
                                <MenuOptions menuOptionsList={getTransactionOptions()} onOptionSelect={(type)=>{
                                        this.setState({mealType:type, selectedRows:[], selection:[] },()=>{
                                            let schoolId = sessionStorage.getItem('SchoolId');
                                            this.getTableData(moment(this.state.startDate).format('YYYY-MM-DD'),schoolId);
                                        })
                                }} selectedOption={(this.state.mealType)} />
                            </div>
                        </div> 

                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive">
                                            <section className="clearfix">
                                                <div className="tab-content">
                                                    <div className="media">
                                                        <div className="panel panel-primary">
                                                            <div className="panel-body">
                                                                <div>
                                                                    <Tabs>
                                                                        <div>
                                                                            <TabList>
                                                                                {gradeList.map((item)=> {
                                                                                    return <Tab key={item.id}
                                                                                        onClick={() => {this.handleTabChange(item.value);
                                                                                    }}>{item.label}</Tab>
                                                                                }, this)}
                                                                            </TabList>
                                                                            <TabPanel>
                                                                                <div className="row">
                                                                                    <div className="col-xs-3 pull-left"></div>
                                                                                    <div className="col-md-9">
                                                                                    <CustomSubmit id="" type="button" className="btn btn-success button-sm pull-right"
                                                                                    style={{
                                                                                        margin: '8px 0'
                                                                                    }} 
                                                                                        handleSubmit={(e, callback) => this.saveOrders(e, callback)}
                                                                                        >
                                                                                        <i className="glyphicon glyphicon-ok"></i> Save Order</CustomSubmit>
                                                                                </div>
                                                                                </div>
                                                                                    <ReactTable
                                                                                        data={tableData}
                                                                                        columns={this.state.columns}
                                                                                        defaultPageSize={10}
                                                                                        className="-striped -highlight"
                                                                                        noDataText='No data found'
                                                                                        sortable={true}
                                                                                        {...checkboxProps}
                                                                                    />
                                                                            </TabPanel>  
                                                                            {gradeList.map(function (key) { 
                                                                                return (
                                                                                    <TabPanel>
                                                                                        <div className="row">
                                                                                        <div className="col-xs-3 pull-left"></div>
                                                                                        <div className="col-md-9">
                                                                                        <CustomSubmit id="" type="button" className="btn btn-success button-sm pull-right"
                                                                                            style={{margin: '8px 0'}} 
                                                                                            handleSubmit={(e, callback) => this.saveOrders(e, callback)}
                                                                                        >
                                                                                        <i className="glyphicon glyphicon-ok"></i> Save Order</CustomSubmit>
                                                                                        </div>
                                                                                        </div>
                                                                                        <ReactTable
                                                                                            data={tableData}
                                                                                            columns={this.state.columns}
                                                                                            defaultPageSize={10}
                                                                                            className="-striped -highlight"
                                                                                            noDataText='No data found'
                                                                                            sortable={true}
                                                                                            {...checkboxProps}
                                                                                        />
                                                                                    </TabPanel> 
                                                                                )
                                                                            }, this)}
                                                                        </div>
                                                                    </Tabs>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/bulkOrdersGrid.js